import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { Observable } from "rxjs";
import { ScientificArchiveFolderDto } from "src/app/models/scientific-archive-folder.model";

@Component({
    selector: 'app-scientific-archive-folder-details',
    templateUrl: './scientific-archive-folder-details.component.html',
    styleUrls: ['./scientific-archive-folder-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScientificArchiveFolderDetailsComponent {

    @Input() details?: ScientificArchiveFolderDto;
    @Output() viewFolder: EventEmitter<number> = new EventEmitter<number>();
    @Output() viewDocument: EventEmitter<number> = new EventEmitter<number>();
    @Input() currentLanguage!: Observable<string>;

    // LABELS = {
    //     numberFolder: 'מספר קלסר',
    //     expedition: 'משלחת',
    //     boxId: 'ארגז',
    //     status: 'סטטוס',
    //     approvals: 'רישיונות לקלסר',
    //     additionalFolders: 'קלסרים נוספים',
    //     folderRisBakIds: 'מספר רישיון',
    //     folderLongId: 'מספר קלסר',
    //     folderTitle: 'כותרת',
    //     documents: 'מסמכים בקלסר',
    //     documentLongId: 'מזהה המסמך',
    //     documentTitle: 'כותרת המסמך'
    // }

    goToFolder(enttyId: number) {
        this.viewFolder.emit(enttyId);
    }

    goToDocument(enttyId: number) {
        this.viewDocument.emit(enttyId);
    }

}